import React from 'react';
import { Result } from 'antd';
import { useAuthStore } from '@/store/authStore';

const SettingsRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { authorization } = useAuthStore();
  const allowed = !!authorization && (
    authorization.globalAdmin || authorization.actions.includes('settings.manage')
  );
  if (!allowed) {
    return (
      <Result
        status="403"
        title="403"
        subTitle="You need the admin role to manage business unit settings."
      />
    );
  }
  return <>{children}</>;
};

export default SettingsRoute;
